const resolveItemLabel = (item, displayKey) => {
  if (item == null) return "";
  if (typeof item === "string" || typeof item === "number") return String(item);
  if (typeof item !== "object") return "";
  if (displayKey && item[displayKey]) return String(item[displayKey]);
  return (
    item.title ||
    item.name ||
    item.label ||
    item.agencyname ||
    (item.value != null ? String(item.value) : "") ||
    (item.id != null ? String(item.id) : "")
  );
};

/**
 * Builds a single filter chip label for multi-select values (names shown, not counts).
 */
export function formatFilterChipMulti(prefix, items, displayKey, maxNames = 3) {
  if (!items?.length) return null;
  const names = items.map((item) => resolveItemLabel(item, displayKey)).filter(Boolean);
  if (!names.length) return `${prefix} (${items.length})`;
  const shown = names.slice(0, maxNames).join(", ");
  const extra = names.length > maxNames ? ` +${names.length - maxNames}` : "";
  return `${prefix}: ${shown}${extra}`;
}

export function getFilterItemKey(item, displayKey) {
  if (item == null) return "";
  if (typeof item !== "object") return String(item);
  if (displayKey && item[displayKey] != null && item[displayKey] !== "") {
    return String(item[displayKey]);
  }
  const fallback =
    item.value ??
    item.id ??
    item.label ??
    item.name ??
    item.title ??
    item.agencyname;
  return fallback != null && fallback !== "" ? String(fallback) : "";
}

/** One badge per selected value (multi-select filters). */
export function expandMultiFilterChips(filterKey, prefix, items, displayKey) {
  const list = !items ? [] : Array.isArray(items) ? items : [items];
  if (!list.length) return [];
  return list.map((item, index) => {
    const itemKey = getFilterItemKey(item, displayKey) || String(index);
    const name = resolveItemLabel(item, displayKey) || itemKey;
    return {
      id: `${filterKey}::${itemKey}`,
      key: filterKey,
      itemKey,
      label: `${prefix}: ${name}`,
    };
  });
}

export function scalarFilterChip(key, label) {
  return { id: key, key, label };
}

export function removeFromMultiFilterState(items, itemKey, displayKey) {
  const target = String(itemKey);
  if (!items) return items;
  if (!Array.isArray(items)) {
    return getFilterItemKey(items, displayKey) === target ? [] : items;
  }
  return items.filter((item) => getFilterItemKey(item, displayKey) !== target);
}
